import Vue from 'vue'
import * as Vuetify from './plugins/vuetify'
import App from './App.vue'
import Auth from './helpers/Auth.js'
import Router from './router.js'
import * as VueGoogleMaps from 'vue2-google-maps'
import moment from 'vue-moment'
import inViewportDirective from 'vue-in-viewport-directive'
import VueTour from 'vue-tour'
import store from './Store/store.js'

import 'vue-tour/dist/vue-tour.css'
import '@fortawesome/fontawesome-free/css/all.css'
import './assets/static/css/main.css'
// import 'vuetify/dist/vuetify.min.css'

import VueScrollPicker from "vue-scroll-picker"

import 'spinkit/css/spinkit.css'

import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'

import VueAnalytics from 'vue-analytics'
import titleMixin from './mixins/titleMixin'
import VueGtag from "vue-gtag"

import VueClipboard from 'vue-clipboard2'



// Initialize Firebase
var config = {
	apiKey: "AIzaSyDKu7X9bkk4KPWNMoNNd09TgsHNTy_vah4",
	authDomain: "duoapp-56ef2.firebaseapp.com",
	databaseURL: "https://duoapp-56ef2.firebaseio.com",
	projectId: "duoapp-56ef2",
    storageBucket: "duoapp-56ef2.appspot.com",
	messagingSenderId: "925303142183"
};
firebase.initializeApp(config)

Vue.use(Vuetify, {
	iconfont: 'fa'
})

Vue.use(VueClipboard)

Vue.use(VueGtag, {
	config: { id: "AW-867600071" }
  })
  
Vue.mixin(titleMixin)
Vue.use(VueAnalytics, {
    id: 'G-P2NGTH0XQQ',
    Router
})

Vue.use(Auth)
Vue.use(VueTour)
Vue.use(VueScrollPicker)

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCZ_lcbWX0z1PYwWrll3MhRmWFOBJnYHm4',
    libraries: 'places'
  }
})

Vue.filter('CLP', function (value) {
	let formatted = new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP' }).format(value)
	return formatted.replace('CLP','$')
})
Vue.filter('formatDate', function(date) {
  return new Date(date).toLocaleString()
})

Vue.directive('in-viewport', inViewportDirective)
Vue.use(moment)

Vue.config.productionTip = false

new Vue({
	store,
	render: h => h(App),
	router: Router,
	
}).$mount('#app')
